import React__default from 'react';
import { Stack } from './Stack.js';

const EditorFieldGroup = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement(Stack, { gap: 1 }, children);
};

export { EditorFieldGroup };
//# sourceMappingURL=EditorFieldGroup.js.map
